export var LIDO_STETH_TOKEN = [
    {
        address: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
        chainId: 1,
    },
];
export var LIDO_WSTETH_TOKEN = [
    {
        address: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
        chainId: 1,
    },
    {
        address: '0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb',
        chainId: 10,
    },
    {
        address: '0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452',
        chainId: 8453,
    },
];
export var LIDO_WITHDRAWAL_QUEUE = [
    {
        address: '0x889edC2eDab5f40e902b864aD4d7AdE8E412F9B1',
        chainId: 1,
    },
];
